import { useDisclosure, useToast } from '@chakra-ui/react';
import { t } from '@lingui/core/macro';
import { trpcAdmin } from '../../lib/trpcAdmin';

export function useCardEdit(
  extraInvalidate?: () => void,
  successTitle?: string,
  errorTitle?: string,
) {
  const toast = useToast();
  const utils = trpcAdmin.useUtils();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onSuccess = () => {
    toast({ status: 'success', title: successTitle ?? t`Employer updated` });
    void utils.workPlacements.employers.getEmployerDetail.invalidate();
    void utils.workPlacements.employers.listEmployers.invalidate();
    extraInvalidate?.();
    onClose();
  };

  const onError = (error: { message: string }) => {
    toast({
      status: 'error',
      title: errorTitle ?? t`Failed to update employer`,
      description: error.message,
    });
  };

  return { isOpen, onOpen, onClose, onSuccess, onError };
}
